export const gtmDataLayer = (eventType) => {
  dataLayer.push({
    event: eventType,
  });
};

export const gtmCustomDataLayer = (name, value) => {
  dataLayer.push({
    [name]: value,
  });
};
